export default {
  API_PRODUCTION_ENDPOINT: 'http://localhost:8080/api',
  API_ENDPOINT: 'https://fathomless-temple-50861.herokuapp.com/api',
  TOKEN_KEY: 'secret-token',
  USER_ID: 'My ID'
}